import { useEffect, useState } from 'react';

const REGISTER_URL = 'https://app.theonestack.com/research';

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 12);
    handler();
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all ${
        scrolled
          ? 'border-b border-white/5 bg-ink-950/80 backdrop-blur'
          : 'border-b border-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <a href="#" className="flex items-center gap-2 group">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-rose-500 to-violet-600 font-black text-white shadow-lg shadow-rose-500/20">
            R
          </span>
          <span className="font-semibold tracking-tight text-white">The One Research</span>
        </a>
        <div className="hidden items-center gap-8 md:flex">
          <a href="#channels" className="text-sm text-slate-400 hover:text-white transition">
            Channels
          </a>
          <a href="#how" className="text-sm text-slate-400 hover:text-white transition">
            How it works
          </a>
          <a href="#use-cases" className="text-sm text-slate-400 hover:text-white transition">
            Use cases
          </a>
          <a href="#pricing" className="text-sm text-slate-400 hover:text-white transition">
            Pricing
          </a>
          <a href="#contact" className="text-sm text-slate-400 hover:text-white transition">
            Contact
          </a>
        </div>
        <div className="flex items-center gap-3">
          <a
            href={REGISTER_URL}
            className="hidden text-sm text-slate-400 hover:text-white transition sm:block"
          >
            Sign in
          </a>
          <a
            href={REGISTER_URL}
            className="rounded-lg bg-rose-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-rose-400"
          >
            Start free
          </a>
        </div>
      </nav>
    </header>
  );
}
